import { motion } from "framer-motion";
import type { CSSProperties, ReactNode } from "react";

interface AnimatedCardProps {
  children: ReactNode;
  as?: "div" | "li";
  className?: string;
  style?: CSSProperties;
}

export function AnimatedCard({
  children,
  as = "div",
  className = "",
  style,
}: AnimatedCardProps): ReactNode {
  const Component = as === "li" ? motion.li : motion.div;

  return (
    <Component
      className={`animated-card ${className}`}
      style={style}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{
        y: -2,
        boxShadow: "var(--shadow-lg)",
        transition: { type: "spring", stiffness: 300, damping: 20 },
      }}
      transition={{ type: "spring", stiffness: 300, damping: 25 }}
    >
      {children}
    </Component>
  );
}
